import { ManageCommon } from "./base-manager.abstract";

export abstract class IglooManage extends ManageCommon {
  protected abstract sdkLoaded: boolean;

  abstract collectData(): any;
}
